import React, { PureComponent, Fragment, createRef } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Input } from 'antd';
import { Version } from '@/services/serdes/serdes';
import { updateConfig } from '../../store/actionCreators';
class ConfigSetting extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      version: null,
      // showInput: false,
      open: false,
      // showInput: false,
      // inputVersion: null,
      name: null,
      datarate: null,
    }

    this.datarateRef = createRef();
    this.nameRef = createRef();
    this.versionRef = createRef();
    this.lock = null;
  }

  componentDidMount() {
    let { Name, SerdesType } = this.props.config;
    let version;
    if (SerdesType.type) {
      version = Version[SerdesType.type];
    }
    this.setState({
      name: Name,
      datarate: SerdesType.datarate,
      version
    })
  }

  render() {

    const { name } = this.state;

    return (
      <Fragment>
        <Row className='serdes-config-row' type="flex" justify="space-around">
          <Col span={24}>
            <span className="font-bold">Name</span>
            <Input
              ref={this.nameRef}
              className='serdes-name-input'
              value={name}
              onChange={this.nameChange}
              onBlur={this.saveName}
              onPressEnter={this.inputNameKeyDown}
            />
          </Col>
        </Row>
      </Fragment>
    )
  }

  nameChange = (e) => {
    this.setState({
      name: e.target.value
    })
  }

  saveName = () => {
    this.props.updateConfig({ Name: this.state.name });
  }

  inputNameKeyDown = () => {
    this.saveName();
    this.nameRef.current.blur();
  }

  versionChange = (value) => {
    let { SerdesType } = this.props.config;
    SerdesType.version = value;
    const index = Version[SerdesType.type].map(ver => ver.type).indexOf(value);
    if (index > 0) {
      SerdesType.datarate = Version[SerdesType.type][index].speed
    }
    this.props.updateConfig({ SerdesType });
    this.versionRef.current.blur();
    this.setState({
      datarate: null
    })
  }

  // lockClose = e => {
  //   clearTimeout(this.lock);
  //   this.lock = setTimeout(() => {
  //     this.lock = null;
  //   }, 100);
  // }

  onDropdownVisibleChange = (open) => {
    if (this.lock) return;
    this.setState({ open });
  }

  dataRateChange = (e) => {
    this.setState({
      datarate: e.target.value
    })
  }

  saveDataRate = () => {
    let { SerdesType } = this.props.config;
    SerdesType.datarate = this.state.datarate;
    this.props.updateConfig({ SerdesType });
    this.setState({
      datarate: null
    })
  }

  inputDataRateKeyDown = () => {
    this.saveDataRate();
    this.datarateRef.current.blur();
  }
}

const mapState = (state) => {
  const { config } = state.explorerSerdes;
  return {
    config
  }
}

const mapDispatch = (dispatch) => ({
  updateConfig(obj) {
    dispatch(updateConfig(obj))
  }
})

export default connect(mapState, mapDispatch)(ConfigSetting);

